import styled from 'styled-components';
import { Menu as MenuPlasma } from '@sms/plasma-ui';

export const Menu = styled(MenuPlasma)`
  background-color: #ffffff;
  border-bottom: 1px solid #c6c6c6;

  .ant-menu-item {
    margin: 0 !important;
    padding: 0 16px !important;
    position: unset;
    padding: 0 16px;

    &:hover {
      color: unset !important;
      border-bottom: 2px solid transparent !important;
    }

    &.ant-menu-item-selected {
      background-color: #0775bc;

      &,
      &:hover {
        color: #fff !important;
        border-bottom: 2px solid #0775bc;
      }
    }
  }
`;

export const MenuItem = styled(MenuPlasma.Item)`
  font-size: 14px;

  span,
  svg {
    color: inherit;
  }

  > div[class^='Icon'] {
    svg {
      font-size: 16px;
      margin-right: 8px;
    }
  }
`;
